import * as Highcharts from 'highcharts'
import roundedCorners from 'highcharts-rounded-corners'

/**
 * Highcharts.relativeLength は highcharts-rounded-corners で使用するのだが、
 * Highchart 4.2.6 ではプロパティとして定義されていないので、
 * Highchart 5.x のソースから持ってきて定義する
 * v5.0.14: https://github.highcharts.com/355aac/highcharts.src.js
 * v4.2.6: https://github.highcharts.com/2bba08f/highcharts.src.js
 */
// eslint-disable-next-line no-import-assign
Highcharts.relativeLength = function (value, base, offset) {
  return /%$/.test(value) ? (base * parseFloat(value)) / 100 + (offset || 0) : parseFloat(value)
}
roundedCorners(Highcharts)

const fontFamily =
  // eslint-disable-next-line max-len
  ' "メイリオ", Meiryo, "游ゴシック", "Yu Gothic", YuGothic, "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", sans-serif '

let chart = null

Highcharts.setOptions({
  lang: {
    thousandsSep: ',',
  },
})
const breakPoint = (isResponsive) => window.outerWidth > 640 || !isResponsive

export function makeChart(id, series, isResponsive) {
  chart = null
  const fontSize = breakPoint(isResponsive) ? '18px' : '12px'
  const monthListForChart = series[0].data.map((v) => v.month)
  // TODO デザイン (margin)
  const _marginTop = 150
  const _marginLeft = 60
  const _marginRight = 60
  const _marginBottom = 80
  const options = {
    chart: {
      marginTop: _marginTop,
      marginLeft: _marginLeft,
      marginRight: _marginRight,
      marginBottom: _marginBottom,
      height: 450,
      backgroundColor: '#fdfbf7',
      borderRadius: 10, // TODO デザイン
      shadow: true,
      style: { fontFamily: fontFamily },
      width: isResponsive ? null : 1110, // TODO デザイン
      styleMode: true,
      events: {
        load: function () {
          const count = this.series[0].points.length - 1
          const points = []
          points.push(this.series[0].points[count])
          points.push(this.series[1].points[count])
          this.tooltip.refresh(points)
        },
      },
    },
    tooltip: {
      shared: true,
      backgroundColor: '#ffebee',
      borderRadius: 20, // TODO デザイン
      borderWidth: 0,
      shadow: false,
      useHTML: true,
      followTouchMove: true,
      // shape: 'callout', // TODO fix 検討 `shared: true` では'callout'は無効
      // TODO デザインfix後表示位置確認
      positioner: function (labelWidth, labelHeight, point) {
        let tooltipX, tooltipY
        const chart = this.chart
        const _plotX = point.plotX + _marginLeft
        const diffWidth = _plotX - chart.plotLeft
        const diffRatio = point.plotX / chart.plotSizeX
        const pointWidth = Math.floor(chart.plotWidth / chart.pointCount)
        if (_plotX - labelWidth < chart.plotLeft) {
          // 画面左のツールチップX軸
          if (diffWidth < labelWidth / 2) {
            tooltipX = _plotX - diffWidth
          } else {
            tooltipX = _plotX - labelWidth / 2
          }
        } else if (_plotX > chart.plotSizeX * 0.5 && _plotX - diffRatio * labelWidth > 0) {
          // 画面右のツールチップX軸
          tooltipX = _plotX - diffRatio * labelWidth
        } else {
          tooltipX = _plotX - labelWidth / 2
        }
        tooltipY = point.plotY - labelHeight + _marginTop - 10
        if (tooltipY <= 0) {
          tooltipY = 0
          tooltipX = _plotX - labelWidth - pointWidth
        }
        return {
          x: tooltipX,
          y: tooltipY,
        }
      },
      formatter: function () {
        if (this.x !== '' && this.x !== ' ') {
          const idx = this.x
          // 年月計算
          let time
          const months = monthListForChart[idx]
          const year = Math.floor(months / 12)
          const month = months % 12
          if (month === 0) {
            time = year + '年目'
          } else {
            time = year === 0 ? month + 'カ月目' : ' ' + year + '年' + month + 'カ月目'
          }
          let s = ''
          const unit = Math.ceil(series[0].data.length / 3)
          const positions = []
          positions.push(unit - 1)
          positions.push(2 * unit - 1)
          positions.push(series[0].data.length - 1)
          const depositPoint = this.points[1]
          const incomePoint = this.points[0]
          // TODO デザイン
          s +=
            '<div class="tooltip-inner"><div class="tooltip-inner-box">' +
            '<p class="tooltip-ttl">' +
            time +
            '</p>' +
            '<hr color="#f98197">' +
            '<table><tr>' +
            '<td><span class="symbol1"></span></td>' +
            '<td>' +
            incomePoint.series.name +
            ':</td>' +
            '<td>' +
            incomePoint.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
            ' 円</td></tr><tr>' +
            '<td class="total"><span class="symbol1"></span><span class="symbol2"></span></td>' +
            '<td>評価額:</td>' +
            '<td>' +
            (depositPoint.y + incomePoint.y).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
            ' 円</td>' +
            '</tr><tr>' +
            '<td><span class="symbol2"></span></td>' +
            '<td>' +
            depositPoint.series.name +
            ':</td>' +
            '<td>' +
            depositPoint.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
            ' 円</td>' +
            '</table>' +
            '</div></div>'
          return s
        } else {
          return false
        }
      },
    },
    credits: {
      enabled: false,
    },
    title: {
      useHTML: true,
      align: 'left',
      style: {
        'background-color': '#e2f2ef',
        'border-radius': '20px',
        padding: breakPoint(isResponsive) ? '10px' : '5px',
        fontSize: breakPoint(isResponsive) ? '14px' : '12px',
        fontWeight: 'bold',
      },
      text: breakPoint(isResponsive)
        ? 'グラフ上にマウスを当てるかタップすると評価額と運用収益を確認できます。'
        : 'グラフ上にマウスを当てるかタップすると<br/>評価額と運用収益を確認できます。',
      x: breakPoint(isResponsive) ? 40 : 10,
      y: breakPoint(isResponsive) ? 20 : 10,
    },
    legend: {
      enabled: false,
      align: 'right',
      verticalAlign: 'top',
      y: 0,
    },
    plotOptions: {
      column: { stacking: 'normal' },
      series: { groupPadding: 0.1 },
    },
    xAxis: {
      categories: series[0].data.map((v) => String(v.x)),
      tickLength: 0,
      tickPositioner: function () {
        const unit = Math.ceil(series[0].data.length / 3)
        const positions = []
        positions.push(series[0].data[unit - 1].x)
        if (series[0].data.length > 1) positions.push(series[0].data[2 * unit - 1].x)

        if (series[0].data.length > 2) positions.push(series[0].data[series[0].data.length - 1].x)

        return positions
      },
      lineColor: '#e8e8e8',
      labels: {
        x: 0,
        style: { fontSize: fontSize },
        useHTML: true,
        formatter: function () {
          const year = Math.floor(monthListForChart[this.value] / 12)
          const month = monthListForChart[this.value] % 12
          if (month === 0) {
            return year + '年目'
          } else {
            return year === 0 ? month + 'カ月目' : ' ' + year + '年' + month + 'カ月目'
          } // TODO デザイン cssで最後のラベル太字化
        },
      },
    },
    yAxis: {
      tickPixelInterval: 1,
      gridLineWidth: 0,
      title: {
        text: null,
      },
      labels: {
        enabled: false,
      },
    },
    series: series,
  }

  chart = Highcharts.chart(id, options)
  return chart
}

export function resetChart() {
  if (chart) {
    chart.destroy()
    chart = null
  }
}
